<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems"
                   class="breadcrumb mx-16">
    </v-breadcrumbs>

    <!-- <v-card> -->
    <v-row dense
           class="mx-16 d-flex justify-center v-step-0">
      <v-col cols="12"
             sm="12"
             md="5"
             xl="5"
             class="mt-2">
        <v-combobox v-model="gene_select"
                    dense
                    clearable
                    clear-icon="mdi-close-circle"
                    :loading="gene_loading"
                    :items="gene_items"
                    :search-input.sync="gene_search"
                    outlined
                    rounded
                    label="Gene Name"
                    :messages="gene_message"
                    :error-messages="gene_error_message"
                    :disabled="is_disable_gene">
        </v-combobox>
      </v-col>
      <v-col cols="12"
             sm="12"
             md="5"
             xl="5"
             class="mt-2">
        <v-select v-model="project_select"
                  outlined
                  rounded
                  dense
                  clearable
                  clear-icon="mdi-close-circle"
                  label="TCGA Project ID"
                  :items="project_items"
                  :error-messages="project_error_message"
                  :disabled="is_disable_project">
        </v-select>
      </v-col>
      <v-col cols="1"
             sm="1"
             md="1"
             xl="1"
             class="mt-2">
        <v-dialog v-model="dialog"
                  :retain-focus="false">
          <template v-slot:activator="{  }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color=""
                       icon
                       @click="dialog=true"
                       v-bind="attrs"
                       v-on="on">
                  <v-icon>mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span>Click here to get the extension of tumor abbreviations.</span>
            </v-tooltip>
          </template>
          <v-card style="left:25%; width:50%">
            <v-card-title class="font-weight-bold grey lighten-2"
                          style="padding:0px 0px 0px 20px">
              TCGA Project ID - Project Name
              <v-spacer></v-spacer>
              <v-btn icon
                     large
                     @click="dialog = false">
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-simple-table dense
                            fixed-header
                            height="600px">
              <template v-slot:default>
                <thead class="font-weight-bold">
                  <tr>
                    <th class="text-left"
                        style="width:30%">Project ID</th>
                    <th class="text-left"
                        style="width:70%">Project Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>TCGA-ACC</td>
                    <td>Adrenocortical Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-BLCA</td>
                    <td>Bladder Urothelial Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-BRCA</td>
                    <td>Breast Invasive Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-CESC</td>
                    <td>Cervical Squamous Cell Carcinoma and Endocervical Adenocarcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-CHOL</td>
                    <td>Cholangiocarcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-COAD</td>
                    <td>Colon Adenocarcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-DLBC</td>
                    <td>Lymphoid Neoplasm Diffuse Large B-cell Lymphoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-ESCA</td>
                    <td>Esophageal Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-GBM</td>
                    <td>Glioblastoma Multiforme</td>
                  </tr>
                  <tr>
                    <td>TCGA-HNSC</td>
                    <td>Head and Neck Squamous Cell Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-KICH</td>
                    <td>Kidney Chromophobe</td>
                  </tr>
                  <tr>
                    <td>TCGA-KIRC</td>
                    <td>Kidney Renal Clear Cell Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-KIRP</td>
                    <td>Kidney Renal Papillary Cell Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-LGG</td>
                    <td>Brain Lower Grade Glioma</td>
                  </tr>
                  <tr>
                    <td>TCGA-LIHC</td>
                    <td>Liver Hepatocellular Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-LUAD</td>
                    <td>Lung Adenocarcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-LUSC</td>
                    <td>Lung Squamous Cell Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-MESO</td>
                    <td>Mesothelioma</td>
                  </tr>
                  <tr>
                    <td>TCGA-OV</td>
                    <td>Ovarian Serous Cystadenocarcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-PAAD</td>
                    <td>Pancreatic Adenocarcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-PCPG</td>
                    <td>Pheochromocytoma and Paraganglioma</td>
                  </tr>
                  <tr>
                    <td>TCGA-PRAD</td>
                    <td>Prostate Adenocarcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-READ</td>
                    <td>Rectum Adenocarcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-SARC</td>
                    <td>Sarcoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-SKCM</td>
                    <td>Skin Cutaneous Melanoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-STAD</td>
                    <td>Stomach Adenocarcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-TGCT</td>
                    <td>Testicular Germ Cell Tumors</td>
                  </tr>
                  <tr>
                    <td>TCGA-THCA</td>
                    <td>Thyroid Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-THYM</td>
                    <td>Thymoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-UCEC</td>
                    <td>Uterine Corpus Endometrial Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-UCS</td>
                    <td>Uterine Carcinosarcoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-UVM</td>
                    <td>Uveal Melanoma</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

    <v-row dense
           class="mt-n4 mx-16 d-flex justify-center">
      <v-col cols="12">
        <v-expansion-panels class="data-table-style">
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="mdi-menu-down"
                                      style="padding: 10px 25px">
              <div class="d-flex font-weight-bold">
                <span class="blue--text font-weight-bold mt-1">Display Columns</span>
                <v-chip outlined
                        small
                        color="success"
                        class="ml-2"
                        @click="showAll()">
                  Select All
                </v-chip>
                <v-chip outlined
                        small
                        color="error"
                        class="ml-2"
                        @click="showDefault()">
                  Select Default
                </v-chip>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="v-item-group">
                <v-checkbox v-for="(header, index) in headers"
                            :key="index"
                            :label="header.text"
                            :value="header.text"
                            v-model="selectedHeader"
                            dense
                            class="mx-1"></v-checkbox>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-data-table dense
                      fixed-header
                      class="data-table-style mt-1 v-step-1"
                      :headers="selectedHeaders"
                      :items="splice_datasets"
                      item-key="_id"
                      :search="search"
                      :loading="loading"
                      loading-text="Loading... Please wait"
                      no-data-text="There is no avaliable alternative splicing events."
                      hide-default-footer
                      :page.sync="currentPage"
                      :items-per-page="pageSize"
                      v-show="selectedHeaders && selectedHeaders.length > 0">
          <template v-slot:item="{ item }">
            <tr :class="selectedEvent && selectedEvent.indexOf(item.event_id) > -1 ? 'blue lighten-5' : ''"
                @click="rowClicked(item)"
                class="v-step-2"
                style="cursor:pointer">
              <!-- <td v-show="selectedHeader.indexOf('Event ID') > -1">{{item.event_id}}
              </td>
              <td v-show="selectedHeader.indexOf('AS Model ID') > -1">{{item.as_model_id}}
              </td> -->
              <td v-show="selectedHeader.indexOf('Source') > -1">{{item.source}}
              </td>
              <td v-show="selectedHeader.indexOf('BioProject') > -1">{{item.project_id}}</td>
              <td v-show="selectedHeader.indexOf('Gene Name') > -1">
                <a @click="goToGeneSearchResult(item.gene_name)">
                  <span class="font-weight-bold">{{item.gene_name}}</span>
                </a>
                <v-icon class="px-1"
                        color="red"
                        v-if="selectedEvent && selectedEvent.indexOf(item.event_id) > -1">mdi-check</v-icon>
              </td>
              <td v-show="selectedHeader.indexOf('Chr') > -1">{{item.chr}}</td>
              <td v-show="selectedHeader.indexOf('Strand') > -1">{{item.strand}}</td>
              <td v-show="selectedHeader.indexOf('Cancer Type') > -1">{{item.cancer_name}}</td>
              <td v-show="selectedHeader.indexOf('Primary Site') > -1">{{item.primary_site}}</td>
              <td v-show="selectedHeader.indexOf('AS Type') > -1">{{item.as_type}}</td>
              <td v-show="selectedHeader.indexOf('Event Coordinates') > -1">{{item.event_coordinates}}</td>
              <td v-show="selectedHeader.indexOf('Alt Coordinates') > -1">{{item.alt_coordinates}}</td>
              <td v-show="selectedHeader.indexOf('ORF') > -1">{{item.orf}}</td>
              <td v-show="selectedHeader.indexOf('Control') > -1">{{item.control}}</td>
              <td v-show="selectedHeader.indexOf('Control Size') > -1">{{item.control_size}}</td>
              <td v-show="selectedHeader.indexOf('Case') > -1">{{item.case}}</td>
              <td v-show="selectedHeader.indexOf('Case Size') > -1">{{item.case_size}}</td>
              <td v-show="selectedHeader.indexOf('Percent Samples') > -1">{{item.pct_samples}}</td>
              <td v-show="selectedHeader.indexOf('PSI Tumor') > -1"> {{item.tumor_psi}}</td>
              <td v-show="selectedHeader.indexOf('PSI Normal') > -1">{{item.normal_psi}}</td>
              <td v-show="selectedHeader.indexOf('Delta PSI') > -1">{{item.dpsi}}</td>
              <td v-show="selectedHeader.indexOf('P Value') > -1">{{item.pvalue}}</td>
              <td v-show="selectedHeader.indexOf('FDR') > -1">{{item.fdr}}</td>
              <td v-show="selectedHeader.indexOf('DASE') > -1">{{item.is_dase}}</td>
              <td v-show="selectedHeader.indexOf('Visualization') > -1">
                <v-btn @click.stop="goToVisualiztion(item.gene_name, item.as_type, item.event_coordinates)"
                       color="info"
                       icon>
                  <v-icon>mdi-tune</v-icon>
                </v-btn>
              </td>
              <td v-show="selectedHeader.indexOf('Survival') > -1">
                <v-btn @click.stop="goToSurvival(item.gene_name, 'TCGA', item.project_id, item.event_id)"
                       color="info"
                       icon
                       :disabled="item.source != 'TCGA' || item.as_type == 'Complex' || !survival_project_items.includes(item.project_id) || item.pct_samples <= 0.3 || item.tumor_psi <= 0.1 || item.tumor_psi == 1">
                  <svg class="icon"
                       aria-hidden="true"
                       v-if="item.source != 'TCGA' || item.as_type == 'Complex' || !survival_project_items.includes(item.project_id) || item.pct_samples <= 0.3 || item.tumor_psi <= 0.1 || item.tumor_psi == 1">
                    <use xlink:href="#icon-linechart-diable"></use>
                  </svg>
                  <svg class="icon"
                       aria-hidden="true"
                       v-else>
                    <use xlink:href="#icon-linechart"></use>
                  </svg>
                </v-btn>
              </td>
              <td v-show="selectedHeader.indexOf('Staging') > -1">
                <v-btn @click.stop="goToStaging(item.gene_name, 'TCGA', item.project_id, item.event_id)"
                       color="info"
                       icon
                       :disabled="item.source != 'TCGA' || item.as_type == 'Complex' || !stage_project_items.includes(item.project_id) || item.pct_samples <= 0.3 || item.tumor_psi <= 0.1 || item.tumor_psi == 1">
                  <svg class="icon"
                       aria-hidden="true"
                       v-if="item.source != 'TCGA' || item.as_type == 'Complex' || !stage_project_items.includes(item.project_id) || item.pct_samples <= 0.3 || item.tumor_psi <= 0.1 || item.tumor_psi == 1">
                    <use xlink:href="#icon-xiangxiantu-disable"></use>
                  </svg>
                  <svg class="icon"
                       aria-hidden="true"
                       v-else>
                    <use xlink:href="#icon-xiangxiantu"></use>
                  </svg>
                </v-btn>
              </td>
            </tr>
          </template>
          <!-- header.pct_samples slot -->
          <template v-slot:[`header.pct_samples`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Percent of samples with PSI values</span>
            </v-tooltip>
          </template>
          <!-- header.dpsi slot -->
          <template v-slot:[`header.dpsi`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Delta PSI = PSI Tumor - PSI Normal</span>
            </v-tooltip>
          </template>
          <!-- header.pvalue slot -->
          <template v-slot:[`header.pvalue`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>p value in Wilcoxon test</span>
            </v-tooltip>
          </template>
          <!-- header.fdr slot -->
          <template v-slot:[`header.fdr`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>FDR value in Wilcoxon test</span>
            </v-tooltip>
          </template>
          <!-- header.is_dase slot -->
          <template v-slot:[`header.is_dase`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Differential Alternative Splicing Events</span><br>
              <span>Filter criteria: |Delta PSI| > 0.1 & FDR < 0.05</span>
            </v-tooltip>
          </template>
          <!-- header.survival slot -->
          <template v-slot:[`header.survival`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Survival Analysis</span>
            </v-tooltip>
          </template>
          <!-- header.staging slot -->
          <template v-slot:[`header.staging`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Cancer Staging Analysis</span>
            </v-tooltip>
          </template>

          <!-- item.data-table-select slot -->
          <!-- <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
            <v-simple-checkbox color="info"
                               :value="isSelected"
                               @input="select($event)"></v-simple-checkbox>
          </template> -->

        </v-data-table>
        <div class="d-flex justify-center mt-1"
             style="max-height:50px"
             v-if="isShowPaginate">
          <span class="text-body-1 mt-3">Items per page</span>
          <v-select v-model="pageSize"
                    dense
                    outlined
                    :items="pageSizes"
                    class="pagesize-select mt-1 mx-2"
                    @input="handlePageSizeChange(pageSize)">
          </v-select>
          <span class="text-body-1 mt-3 mx-2">Total <span class="font-weight-bold info--text">{{totalItems}}</span>
            items </span>
          <v-pagination v-model="currentPage"
                        color="info"
                        :length="totalPages"
                        :total-visible="5"
                        class="mx-1"
                        @input="handlePageChange"
                        prev-icon="mdi-menu-left"
                        next-icon="mdi-menu-right">
          </v-pagination>
          <span class="text-body-1 mt-2 mx-2">Page</span>
          <v-text-field outlined
                        dense
                        v-model="whichPage"
                        type="number"
                        class="jump-select"
                        append-icon="">
          </v-text-field>
          <v-btn color=""
                 depressed
                 outlined
                 class="mx-2"
                 @click="jumpPage()">Jump</v-btn>
        </div>
      </v-col>
      <v-col cols="12"
             class="d-flex justify-center">
        <v-tooltip bottom>
          <template v-slot:activator="{on, attrs}">
            <v-btn color="info"
                   class="v-step-3"
                   rounded
                   outlined
                   @click="Go(selectedEvent && selectedEvent[0])"
                   v-preventReClick
                   v-bind="attrs"
                   v-on="on"
                   :loading="go_loading"
                   :disabled="splice_datasets.length == 0 || selectedEvent.length == 0">
              Go !
              <v-icon right
                      small>mdi-run-fast</v-icon>
            </v-btn>
          </template>
          <span>Change the selected event by clicking the row.</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-row dense
           class="mx-16"
           v-show="samplePsi && samplePsi.length > 0">
      <v-col cols="12">
        <v-alert color="error"
                 text
                 dense
                 outlined
                 border="left"
                 elevation="1"
                 icon="mdi-information"
                 v-show="isShowNoPsiText">Sorry, there is no PSI values for this splicing event!</v-alert>
      </v-col>

      <!-- Splice Mutation Explorer-->
      <v-col cols="12"
             lg="12"
             md="12"
             sm="12"
             v-show="!isShowNoPsiText"
             class="v-step-4">
        <v-card id="splice-mutation-explorer">
          <v-card-title class="font-weight-bold grey lighten-2"
                        style="width:100%">
            Splicing Mutation Explorer
          </v-card-title>
          <div id="mutation-gene-search"
               class="d-flex flex-row">
            <v-combobox v-model="mutation_gene_select"
                        class="mb-n14 mt-4"
                        dense
                        rounded
                        clearable
                        clear-icon="mdi-close-circle"
                        :loading="mutation_gene_loading"
                        :items="mutation_gene_items"
                        :search-input.sync="mutation_gene_search"
                        outlined
                        placeholder="Gene Name"
                        :messages="mutation_gene_message"
                        :error-messages="mutation_gene_error_message">
            </v-combobox>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs"
                        v-on="on"
                        class="mt-5 ml-2">mdi-help-circle</v-icon>
              </template>
              <span>Add custom Gene</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon
                       outlined
                       x-small
                       color="info"
                       class="mt-5 ml-1"
                       style="padding:10px"
                       v-bind="attrs"
                       v-on="on"
                       @click="downloadOncoprint"
                       :disabled="progress_value_1 != 100">
                  <v-icon small>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>Download oncoprint</span><br>
            </v-tooltip>
          </div>
          <div id="psi-legend1">
            <svg></svg>
          </div>
          <sample-psi-mutation :sample-psi="samplePsi"
                               :project-id="project_select"
                               :sample-psi-id="psi_id1">
          </sample-psi-mutation>
          <v-progress-circular v-show="isShowProgress1"
                               :rotate="-90"
                               :size="80"
                               :width="10"
                               :value="progress_value_1"
                               indeterminate
                               color="primary">
            {{ progress_value_1 }}
          </v-progress-circular>
          <sample-mutation v-for="(data, index) in mutationIndexes"
                           :key="index"
                           :sample-id="sampleIDs"
                           :sample-mutation-id="mutationGeneNames[data]"
                           :p-value="pValues_mut[data]"
                           :sample-mutation="sampleMutations[data]"
                           :sample-cnv="sampleCNVs[data]"
                           v-show="sampleCNVs[data]">
          </sample-mutation>
          <div id="mutation-legend">
            <svg></svg>
          </div>
        </v-card>
      </v-col>

      <!-- Splice Expression Explorer-->
      <!-- Expression Heatmap-->
      <v-col cols="12"
             class="mt-2"
             v-show="!isShowNoPsiText">
        <v-card>
          <v-card-title class="font-weight-bold grey lighten-2">
            Splicing Expression Explorer
          </v-card-title>
          <v-row dense>
            <v-col cols="12"
                   sm="12"
                   lg="8"
                   md="8"
                   class="v-step-5">
              <div id="splice-expression-heatmap">
                <div id="heatmap-gene-search"
                     class="d-flex flex-row">
                  <v-combobox v-model="express_gene_select"
                              class="mb-n16 mt-4"
                              dense
                              rounded
                              clearable
                              clear-icon="mdi-close-circle"
                              :loading="express_gene_loading"
                              :items="express_gene_items"
                              :search-input.sync="express_gene_search"
                              outlined
                              placeholder="Gene Name"
                              :messages="express_gene_message"
                              :error-messages="express_gene_error_message">
                  </v-combobox>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs"
                              v-on="on"
                              class="mt-5 ml-2">mdi-help-circle</v-icon>
                    </template>
                    <span>Add custom Gene</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon
                             outlined
                             x-small
                             color="info"
                             class="mt-5 ml-1"
                             style="padding:10px"
                             v-bind="attrs"
                             v-on="on"
                             @click="downloadHeatmap"
                             :disabled="progress_value_2 != 100">
                        <v-icon small>mdi-download</v-icon>
                      </v-btn>
                    </template>
                    <span>Download heatmap</span><br>
                  </v-tooltip>
                </div>
                <div id="psi-legend2">
                  <svg></svg>
                </div>
                <sample-psi-expression :sample-psi="samplePsi"
                                       :project-id="project_select"
                                       :sample-psi-id="psi_id2">
                </sample-psi-expression>
                <v-progress-circular v-show="isShowProgress2"
                                     :rotate="-90"
                                     :size="80"
                                     :width="10"
                                     :value="progress_value_2"
                                     indeterminate
                                     color="primary">
                  {{ progress_value_2 }}
                </v-progress-circular>
                <sample-expression v-for="(data,index) in expressionIndexes"
                                   :key="index"
                                   :sample-id="sampleIDs"
                                   :sample-expression-id="expressionGeneNames[data]"
                                   :p-value="pValues_exp[data]"
                                   :r-value="rValues_exp[data]"
                                   :sample-expression="sampleExpressions[data]"
                                   v-show="sampleExpressions[data]">
                </sample-expression>
                <div id="expression-legend">
                  <svg></svg>
                </div>
              </div>
            </v-col>

            <v-col cols="12"
                   sm="12"
                   lg="4"
                   md="4"
                   class="v-step-6">
              <div id="splice-expression-scatter">
                <div id="scatter-gene-search"
                     class="mb-n14 mt-4">
                  <v-combobox v-model="exp_scatter_gene_select"
                              dense
                              rounded
                              clearable
                              clear-icon="mdi-close-circle"
                              :loading="exp_scatter_gene_loading"
                              :items="exp_scatter_gene_items"
                              :search-input.sync="exp_scatter_gene_search"
                              outlined
                              placeholder="Gene Name"
                              :messages="exp_scatter_gene_message"
                              :error-messages="exp_scatter_gene_error_message">
                  </v-combobox>
                </div>
                <v-progress-circular v-show="isShowProgress3"
                                     class="mt-10"
                                     :rotate="-90"
                                     :size="80"
                                     :width="10"
                                     :value="progress_value_3"
                                     indeterminate
                                     color="primary">
                  {{ progress_value_3 }}
                </v-progress-circular>
                <sample-expression-scatter :scatter-data="scatter_data"
                                           :p-value="scatter_p"
                                           :r-value="scatter_r"
                                           :error-message="scatter_error"
                                           v-show="scatter_p">
                </sample-expression-scatter>
              </div>
            </v-col>
          </v-row>

        </v-card>
      </v-col>
    </v-row>

    <!-- back to top -->
    <!-- <easy-go-top :right="10"
                 innerHTML="<svg viewBox='0 0 16 16'><g><path d='M12.036 15.59c0 .55-.453.995-.997.995H5.032c-.55 0-.997-.445-.997-.996V8.584H1.03c-1.1 0-1.36-.633-.578-1.416L7.33.29c.39-.39 1.026-.385 1.412 0l6.878 6.88c.782.78.523 1.415-.58 1.415h-3.004v7.004z' fill-rule='evenodd'></path></g></svg>">
    </easy-go-top> -->
    <back-to-top></back-to-top>

    <!-- User guide -->
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="guide-btn-style primary"
               fab
               small
               icon
               v-bind="attrs"
               v-on="on"
               @click="$tours['myTour'].start()">
          <v-icon color="white">mdi-book-cog</v-icon>
        </v-btn>
      </template>
      <span>User Guide</span>
    </v-tooltip>

    <v-tour name="myTour"
            :steps="steps"
            :options="{ highlight: true }"></v-tour>
    <!-- </v-card> -->
  </v-container>
</template>

<script>
import * as d3 from 'd3';
import { getSpliceDatasets, getAllProjectByGene } from 'node/browse.js';
import { getAllGeneFromSpliceDataset } from 'node/browse';
import {
  findPSIByEventAndCancer,
  getMutationPvalues, findMutationByGeneAndCancer, findMutationGeneByCancer,
  findCNVByGeneAndCancer,
  getExpressionPvalues, findExpressionByGeneAndCancer, findExpressionGeneByCancer,
  getPsiExpressionScatter
} from 'node/splice_regulation_explorer';
import SamplePsiMutation from './SamplePsiMutation';
import SampleMutation from './SampleMutation';
import SamplePsiExpression from './SamplePsiExpression';
import SampleExpression from './SampleExpression';
import SampleExpressionScatter from './SampleExpressionScatter';
import BackToTop from '@/components/main/BackToTop';
import axios from 'axios';

export default {
  name: 'SpliceRegulationExplorer',
  components: {
    SamplePsiMutation,
    SampleMutation,
    SamplePsiExpression,
    SampleExpression,
    SampleExpressionScatter,
    BackToTop
  },
  data() {
    return {
      breadItems: [
        {
          text: 'Home',
          disabled: false,
          href: '/ascancer/home',
        },
        {
          text: 'Toolkit',
          disabled: false,
          href: '/ascancer/tools',
        },
        {
          text: 'Splicing Regulatory Explorer',
          disabled: true,
        },
      ],

      steps: [{
        target: '.v-step-0',
        content: `1. Input the <span class='font-weight-bold info--text'>Gene Name</span> and <span class='font-weight-bold info--text'>TCGA Project ID</span> !`,
        params: {
          placement: 'bottom',
          enableScrolling: false
        }
      },
      {
        target: '.v-step-1',
        content: `2. Show the <span class='font-weight-bold info--text'>filtered splicing events</span> based on the selected Gene Name and TCGA Project ID !<br/>`,
        params: {
          enableScrolling: false
        }
      },
      {
        target: '.v-step-2',
        content: `3. The <span class="font-weight-bold info--text" style="color:#E3F2FD">blue background</span> in the table represents the currently selected splicing event.
        The first row is choosed by default. You can click on any row to switch the selected event.`,
        params: {
          enableScrolling: false
        }
      }, {
        target: '.v-step-3',
        content: `4. <span class='font-weight-bold info--text'>Submit</span> the selected splicing event !`,
        params: {
          enableScrolling: false
        }
      }, {
        target: '.v-step-4',
        content: `5. Explore the potential regulatory mechanism of the selected splicing event based on TCGA <span class="font-weight-bold info--text">genetic variants (SNV / CNV)</span> evidence.<br/>
        The top 10 genes with <span class="font-weight-bold info--text">Fisher's exact test</span> p value are displayed by default. Support to add custom genes.`,
        params: {
          enableScrolling: true
        }
      }, {
        target: '.v-step-5',
        content: `6. Explore the potential regulatory mechanism of the selected splicing event based on TCGA <span class="font-weight-bold info--text">transcriptional expression</span> evidence.<br/>
        The top 10 genes with <span class="font-weight-bold info--text">Pearson correlation analysis</span> p value are displayed by default. Support to add custom genes.`,
        params: {
          enableScrolling: true
        }
      }, {
        target: '.v-step-6',
        content: `7. Explore the <span class="font-weight-bold info--text">correlation</span> between gene expression and alternative splicing of the selected splicing event. Support custom genes.`,
        params: {
          enableScrolling: true
        }
      },],

      search: '',
      loading: true,
      currentPage: 1,
      whichPage: 1,
      totalPages: 0,
      pageSize: 5,
      pageSizes: [5, 10, 15, 20, 50, 100],
      totalItems: 0,
      isShowPaginate: true,

      selectedHeader: ['Gene Name', 'Cancer Type', 'AS Type',
        'Event Coordinates', 'ORF', 'PSI Tumor', 'PSI Normal', 'Delta PSI', 'FDR',
        'DASE', 'Visualization', 'Survival', 'Staging'],
      headers: [
        // { text: 'Event ID', value: 'event_id', align: 'start', sortable: false, },
        // { text: 'AS Model ID', value: 'as_model_id', align: 'start', sortable: false, },
        { text: 'Source', value: 'source', align: 'start', sortable: false, },
        { text: 'BioProject', value: 'project_id', align: 'start', sortable: false, },
        { text: 'Gene Name', value: 'gene_name', align: 'start', sortable: false, },
        { text: 'Chr', value: 'chr', align: 'start', sortable: false, },
        { text: 'Strand', value: 'strand', align: 'start', sortable: false, },
        { text: 'Cancer Type', value: 'cancer_name', align: 'start', sortable: false },
        { text: 'Primary Site', value: 'tissue', align: 'start', sortable: false, },
        { text: 'AS Type', value: 'as_type', align: 'start', sortable: true, },
        { text: 'Event Coordinates', value: 'event_coordinates', align: 'start', sortable: true, },
        { text: 'Alt Coordinates', value: 'alt_coordinates', align: 'start', sortable: false, },
        { text: 'ORF', value: 'orf', align: 'start', sortable: false, },
        { text: 'Control', value: 'control', align: 'start', sortable: false, },
        { text: 'Control Size', value: 'control_size', align: 'start', sortable: false, },
        { text: 'Case', value: 'case', align: 'start', sortable: false, },
        { text: 'Case Size', value: 'case_size', align: 'start', sortable: false, },
        { text: 'Percent Samples', value: 'pct_samples', align: 'start', sortable: false, },
        { text: 'PSI Tumor', value: 'tumor_psi', align: 'start', sortable: false, },
        { text: 'PSI Normal', value: 'normal_psi', align: 'start', sortable: false, },
        { text: 'Delta PSI', value: 'dpsi', align: 'start', sortable: false, },
        { text: 'P Value', value: 'pvalue', align: 'start', sortable: false, },
        { text: 'FDR', value: 'fdr', align: 'start', sortable: false, },
        { text: 'DASE', value: 'is_dase', align: 'start', sortable: false, },
        { text: 'Visualization', value: 'visualization', align: 'center', sortable: false, },
        { text: 'Survival', value: 'survival', align: 'center', sortable: false, },
        { text: 'Staging', value: 'staging', align: 'center', sortable: false, },
      ],
      splice_datasets: [],
      source_select: null,

      selectedEvent: [],
      routeEvent: null,
      runedEvent: [], // 此变量用于保存运行过的event_id
      // selectedRow: {},

      gene_select: null,
      gene_search: null,
      gene_list: [],
      gene_items: [],
      gene_loading: false,
      gene_message: null,
      gene_error_message: null,
      is_disable_gene: false,

      source_select: 'TCGA',

      project_select: null,
      project_items: ["TCGA-ACC", "TCGA-BLCA", "TCGA-BRCA", "TCGA-CESC", "TCGA-CHOL",
        "TCGA-COAD", "TCGA-DLBC", "TCGA-ESCA", "TCGA-GBM", "TCGA-HNSC", "TCGA-KICH",
        "TCGA-KIRC", "TCGA-KIRP", "TCGA-LAML", "TCGA-LGG", "TCGA-LIHC", "TCGA-LUAD",
        "TCGA-LUSC", "TCGA-MESO", "TCGA-OV", "TCGA-PAAD", "TCGA-PCPG", "TCGA-PRAD",
        "TCGA-READ", "TCGA-SARC", "TCGA-SKCM", "TCGA-STAD", "TCGA-TGCT", "TCGA-THCA",
        "TCGA-THYM", "TCGA-UCEC", "TCGA-UCS", "TCGA-UVM",
      ], // 隐藏 TCGA-LAML
      survival_project_items: ["TCGA-ACC", "TCGA-BLCA", "TCGA-BRCA", "TCGA-CESC", "TCGA-CHOL",
        "TCGA-COAD", "TCGA-DLBC", "TCGA-ESCA", "TCGA-GBM", "TCGA-HNSC", "TCGA-KICH",
        "TCGA-KIRC", "TCGA-KIRP", "TCGA-LAML", "TCGA-LGG", "TCGA-LUAD", "TCGA-LUSC", "TCGA-MESO",
        "TCGA-OV", "TCGA-PAAD", "TCGA-PCPG", "TCGA-PRAD", "TCGA-READ", "TCGA-SARC",
        "TCGA-SKCM", "TCGA-STAD", "TCGA-THCA", "TCGA-THYM", "TCGA-UCEC", "TCGA-UCS", "TCGA-UVM",
      ],
      stage_project_items: ["TCGA-ACC", "TCGA-BLCA", "TCGA-BRCA", "TCGA-CHOL",
        "TCGA-COAD", "TCGA-ESCA", "TCGA-HNSC", "TCGA-KICH", "TCGA-KIRC", "TCGA-KIRP",
        "TCGA-LUAD", "TCGA-LUSC", "TCGA-MESO", "TCGA-PAAD", "TCGA-READ", "TCGA-SKCM",
        "TCGA-STAD", "TCGA-THCA",
      ],
      project_error_message: null,
      dialog: false,
      is_disable_project: false,

      event_select: null,

      // splice mutation explorer
      mutation_gene_select: null,
      mutation_gene_search: null,
      mutation_gene_list: [],
      mutation_gene_items: [],
      mutation_gene_loading: false,
      mutation_gene_message: null,
      mutation_gene_error_message: null,
      mutation_pvalue_list: [],

      // splice expression explorer
      // expression heatmap
      express_gene_select: null,
      express_gene_search: null,
      express_gene_list: [],
      express_gene_items: [],
      express_gene_loading: false,
      express_gene_message: null,
      express_gene_error_message: null,
      express_pvalue_list: [],
      express_rvalue_list: [],

      // expression scatter
      exp_scatter_gene_select: null,
      exp_scatter_gene_search: null,
      exp_scatter_gene_list: [],
      exp_scatter_gene_items: [],
      exp_scatter_gene_loading: false,
      exp_scatter_gene_message: null,
      exp_scatter_gene_error_message: null,
      scatter_data: [],
      scatter_p: null,
      scatter_r: null,
      scatter_error: null,

      isShowNoPsiText: false,
      progress_value_1: 40,
      progress_value_2: 40,
      progress_value_3: 40,

      sampleIDs: [],
      samplePsi: [],

      psi_id1: "psi-id1",
      psi_id2: "psi-id2",

      mutationGeneNames: [],
      sampleMutations: [],
      sampleCNVs: [],
      pValues_mut: [],
      mutationIndexes: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],

      expressionGeneNames: [],
      sampleExpressions: [],
      pValues_exp: [],
      rValues_exp: [],
      expressionIndexes: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],

      request1: null,// 记录当前请求
      request2: null,// 记录当前请求

      go_loading: false,

    }
  },
  created() {
    // this.getAllGeneFromSpliceDataset().then(() => {
    if (JSON.stringify(this.$route.query) === '{}') {
      // console.log('query is null');
      setTimeout(() => {
        this.source_select = "TCGA";
        this.gene_select = "EZH2";
        this.project_select = "TCGA-LAML";
        this.changeRoute();
      }, 10);
    } else if (Object.keys(this.$route.query).includes('eventid')) {
      setTimeout(() => {
        if (this.$route.query.genename) {
          this.gene_select = this.$route.query.genename;
        } else {
          // window.alert('Please enter the Gene Name !')
          this.gene_error_message = "Please enter the Gene Name !";
        }
        if (this.$route.query.source) {
          this.source_select = "TCGA";
        }
        if (this.project_items.includes(this.$route.query.project)) {
          this.project_select = this.$route.query.project;
        } else {
          // window.alert('Please enter the TCGA Project ID !')
          this.project_error_message = "Please select the TCGA Project ID !"
        }

        this.routeEvent = this.$route.query.eventid;
        // if (this.$route.query.eventid) {
        //   this.selectedEvent.push(this.$route.query.eventid);
        //   console.log(this.selectedEvent);
        // } else {
        //   this.selectedEvent = [];
        // }
      }, 10)
    } else if (JSON.stringify(this.$route.query) !== '{}') {
      setTimeout(() => {
        if (this.$route.query.genename) {
          this.gene_select = this.$route.query.genename;
        } else {
          // window.alert('Please enter the Gene Name !')
          this.gene_error_message = "Please enter the Gene Name !";
        }
        if (this.$route.query.source) {
          this.source_select = "TCGA";
        }
        if (this.project_items.includes(this.$route.query.project)) {
          this.project_select = this.$route.query.project;
        } else {
          // window.alert('Please enter the TCGA Project ID !')
          this.project_error_message = "Please select the TCGA Project ID !"
        }
      }, 10);
    }
    // });

    // Load external svg2pdf js scripts
    const script1 = document.createElement("script");
    script1.type = "text/javascript";
    script1.src =
      "https://ngdc.cncb.ac.cn/ascancer/api/js/pdfkit.standalone.js";
    document.body.appendChild(script1);

    const script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.src = "https://ngdc.cncb.ac.cn/ascancer/api/js/svg-to-pdfkit.js";
    document.body.appendChild(script2);
  },
  mounted() {
    this.getAllGeneFromSpliceDataset();
    this.plotPSILegend1();
    this.plotPSILegend2();
    this.plotMutationLegend();
    this.plotExpressLegend();
  },

  computed: {
    selectedHeaders() {
      return this.headers.filter(h => this.selectedHeader.includes(h.text))
    },
    // watch multi data props meanwhile.
    listenMultiData() {
      const { gene_select, source_select, project_select } = this;
      return {
        gene_select, source_select, project_select
      }
    },
    // watch progress_value_1, progress_value_2, progress_value_3
    listenProgressValue() {
      const { progress_value_1, progress_value_2, progress_value_3 } = this;
      return {
        progress_value_1, progress_value_2, progress_value_3
      }
    },
    isShowProgress1() {
      if (this.progress_value_1 == 100) {
        return false
      } else {
        return true
      }
    },
    isShowProgress2() {
      if (this.progress_value_2 == 100) {
        return false
      } else {
        return true
      }
    },
    isShowProgress3() {
      if (this.progress_value_3 == 100) {
        return false
      } else {
        return true
      }
    },
    // isLoading() {
    //   if (this.splice_datasets == 0 || this.selectedEvent.length == 0) {
    //     return false
    //   } else if (this.progress_value_1 == 100 && this.progress_value_2 == 100) {
    //     return false
    //   }
    // }
  },
  watch: {
    splice_datasets(val) {
      if (val) {
        this.loading = false;
      }
    },
    gene_search(val) {
      val && val !== this.gene_select && this.querySelections(val)
    },
    gene_select(val) {
      // console.log(val);
      if (val == this.$route.query.genename) { // 这里不能写死，不然返回不了
        this.gene_select = val;
        this.gene_message = null;
        this.currentPage = 1; // default show the first page
        this.whichPage = 1;

        this.selectedEvent = [];
        this.changeRoute();
        this.getAllProjectByGene(); // find All Project By Gene
      } else if (val == null || val == "") {
        this.gene_message = "Please enter the Gene Name."
      } else if (val && this.gene_list.includes(val)) {
        this.gene_select = val;
        this.gene_message = null;
        this.currentPage = 1; // default show the first page
        this.whichPage = 1;

        this.selectedEvent = [];
        this.changeRoute();
        this.getAllProjectByGene(); // find All Project By Gene
      } else {
        // window.alert("Sorry, we cant' find this gene.");
        this.gene_select = null;
      };
    },
    project_select(val) {
      if (val && this.project_items.includes(val)) {
        this.project_error_message = null;
        this.project_select = val;
        this.currentPage = 1; // default show the first page
        this.whichPage = 1;

        this.selectedEvent = [];
        this.changeRoute();
      }
    },
    listenMultiData(val) {
      if (val.gene_select && val.source_select && val.project_select) {
        // console.log('hahaha');

        this.findMutationGeneByCancer(); // get mutation_gene_list based on project_id
        this.findExpressionGeneByCancer(); // get expression_gene_list based on project_id

        this.getSpliceDatasets().then(() => {

          // default select the first
          if (this.gene_select == "EZH2" && this.project_select == "TCGA-LAML") {
            // console.log('hahaha');
            this.initFirstEvent();
          }

          if (this.routeEvent) {
            this.selectedEvent.push(this.routeEvent);
            // console.log(this.selectedEvent);
          }
        });
      }
    },
    listenProgressValue(val) {
      if (val.progress_value_1 == 100 && val.progress_value_2 == 100 && val.progress_value_3 == 100) {
        this.is_disable_gene = false;
        this.is_disable_project = false;
      } else {
        this.is_disable_gene = true;
        this.is_disable_project = true;
      }
    },
    mutation_gene_search(val) {
      val && val !== this.mutation_gene_select && this.mutationQuerySelections(val)
    },
    mutation_gene_select(val) {
      // console.log(val);
      if (val == null || val == "") {
        this.mutation_gene_message = "Please enter the Gene Name."
      } else if (val && this.mutation_gene_list.includes(val)) {
        this.mutation_gene_select = val;
        this.mutation_gene_message = null;
        this.addNewMutationGene();
      } else {
        // window.alert("Sorry, we cant' find this gene.");
        this.mutation_gene_select = null;
      };
    },

    express_gene_search(val) {
      val && val !== this.express_gene_select && this.expressQuerySelections(val)
    },
    express_gene_select(val) {
      // console.log(val);
      if (val == null || val == "") {
        // this.express_gene_message = "Please enter the Gene Name."
        this.express_gene_message = null
      } else if (val && this.express_gene_list.includes(val)) {
        this.express_gene_select = val;
        this.express_gene_message = null;
        this.addNewExpressGene();
      } else {
        // window.alert("Sorry, we cant' find this gene.");
        this.express_gene_select = null;
      };
    },

    exp_scatter_gene_search(val) {
      val && val !== this.exp_scatter_gene_select && this.expScatterQuerySelections(val)
    },
    exp_scatter_gene_select(val) {
      if (val == null || val == "") {
        this.exp_scatter_gene_message = "Please enter the Gene Name."
      } else if (val && this.exp_scatter_gene_list.includes(val)) {
        this.exp_scatter_gene_select = val;
        this.exp_scatter_gene_message = null;

        // let data = {
        //   "psi": this.samplePsi,
        //   "project": this.project_select,
        //   "genename": this.exp_scatter_gene_select
        // }

        // 此处必须这样写！
        let data = new URLSearchParams();
        data.append('psi', JSON.stringify(this.samplePsi));
        data.append('project', this.project_select);
        data.append('genename', this.exp_scatter_gene_select);
        // console.log(data);
        this.getPsiExpressionScatter(data);
      } else {
        // window.alert("Sorry, we cant' find this gene.");
        this.exp_scatter_gene_select = null;
      };
    }
  },
  methods: {
    getRequestParams(genename, source, project, page, pageSize) {
      let params = {};

      if (genename) {
        params["genename"] = genename;
      }

      if (source) {
        params["source"] = source;
      }

      if (project) {
        params["project"] = project;
      }

      if (page) {
        params["page"] = page - 1;
      }

      if (pageSize) {
        params["size"] = pageSize;
      }

      return params;
    },
    async getSpliceDatasets(size) {

      // Handle page size change
      // if (size) {
      //   this.pageSize = size;
      // } else if (this.project_select == "TCGA-LAML") {
      //   this.pageSize = 300;
      // } else {
      //   this.pageSize = 5;
      // }

      this.pageSize = 300;

      const params = this.getRequestParams(
        this.gene_select,
        this.source_select,
        this.project_select,
        this.currentPage,
        this.pageSize,
      );
      await getSpliceDatasets(params).then(
        data => {

          // console.log(data);

          if (data) {

            this.runedEvent = []; // 去除之前运行过的旧事件

            // 去除之前选择的旧事件
            if (this.selectedEvent.length > 0) {
              this.selectedEvent = [];
            }

            // console.log(data);
            if (this.project_select == "TCGA-LAML") {
              // console.log(data);
              this.isShowPaginate = false;
              let items = data.items && data.items.filter(d => {
                return d.pct_samples > 0.3 && d.tumor_psi > 0.1 && d.tumor_psi < 1
              });
              // console.log(items);

              if (items.length > 0) {
                // move the ezh2_9b event to the first one.
                if (this.gene_select == "EZH2") {
                  let ezh2_9b = items.splice(0, 1);
                  // console.log(ezh2_9b);
                  items.unshift(ezh2_9b[0])
                }
                // console.log(items);
                this.splice_datasets = items;
              } else {
                this.splice_datasets = [];
              }
            } else if (this.gene_select == "PPP2R5A") {
              this.isShowPaginate = false;
              // unique the event_id
              let rr = new Map();
              let items = data.items && data.items.filter((a) => !rr.has(a.event_id) && rr.set(a.event_id, 1));
              if (items.length > 0) {
                this.splice_datasets = items;
              }
            } else {
              // console.log(data);
              this.isShowPaginate = false;
              // this.totalItems = data.totalItems;
              // this.currentPage = data.currentPage;
              // this.totalPages = data.totalPages;
              // this.splice_datasets = data.items;

              // unique the event_id
              let rr = new Map();
              let items = data.items && data.items.filter((a) => !rr.has(a.event_id) && rr.set(a.event_id, 1) && a.tumor_psi > 0);
              // console.log(items);
              if (items.length > 0) {
                this.splice_datasets = items;
              } else {
                this.splice_datasets = [];
              }
            }
          }
        }
      ).catch(err => console.error(err))
    },
    async getAllProjectByGene() {
      let genename = this.gene_select;
      await getAllProjectByGene(genename).then(data => {
        if (data) {
          // console.log(data);
          this.project_items = data;
        }
      }).catch(err => {
        console.error(err);
      })
    },
    initFirstEvent() {
      // EZH2_9b event
      // this.selectedEvent[0] = "EZH2_chr7_-_ES_148515129:148515209:148516070:148516151:148516688:148516779";

      // select the first event defaultly
      let item = this.splice_datasets && this.splice_datasets[0];
      // console.log(item);
      if (item) {
        this.selectedEvent[0] = item && item.event_id;
        this.Go(item.event_id);
      }
    },
    rowClicked(item) {
      // if (this.progress_value_1 != 100 && this.progress_value_2 != 100) {
      //   // window.alert('Please wait for the current event to finish!')
      // } else {
      // console.log(item);
      if (this.selectedEvent[0] !== item.event_id) {
        this.selectedEvent = []; // first empty the array
        this.selectedEvent.push(item.event_id);
      }
      // }
    },
    Go(event_id) {
      // console.log(this.runedEvent);
      // console.log(event_id);

      this.changeRoute(); // change the route (add eventid) when run Go!

      if (!this.runedEvent.includes(event_id)) {

        this.go_loading = true; // start go loading

        // console.log(this.request1);
        if (this.request1 || this.request2) {
          this.cancel();
        }

        // first remove the psi and mutation, init
        this.removeSamplePsiPlot();
        this.removeSampleMutationPlot();
        this.removeSampleExpressionPlot();

        this.mutationIndexes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        this.expressionIndexes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        this.mutation_gene_select = null;
        this.express_gene_select = null;

        this.exp_scatter_gene_select = null;

        this.progress_value_1 = 40;
        this.progress_value_2 = 40;
        this.progress_value_3 = 40;

        this.findPSIByEventAndCancer(this.selectedEvent.join(''), this.project_select).then(
          () => {
            // console.log(this.samplePsi.toString() == samplePsi.toString()); // 判断两个数组是否相等
            // two conditions
            if (this.samplePsi.length > 0) {

              this.isShowNoPsiText = false;

              this.exp_scatter_gene_select = this.gene_select; // update the exp_scatter_gene_select when go!

              // let data = {
              //   "psi": this.samplePsi,
              //   "project": this.project_select
              // };
              let data = new URLSearchParams();
              data.append('psi', JSON.stringify(this.samplePsi));
              data.append('project', this.project_select);
              data.append('genename', this.exp_scatter_gene_select);

              this.getMutationPvalues(data);
              this.getExpressionPvalues(data);
              this.getPsiExpressionScatter(data);

              this.runedEvent.splice(0, 1); // delete the first element, make the runedEvent.length = 1
              this.runedEvent.push(event_id); // 此变量用于保存已经运行过的 event_id

            } else {
              this.isShowNoPsiText = true;
              this.progress_value_1 = 100; // hide the progress
              this.progress_value_2 = 100; // hide the progress
              this.progress_value_3 = 100; // hide the progress
            }
          }
        );
      } else {
        // console.log('The event is same !');
        // window.alert('This event has been explored, please select other events !')
      }
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.whichPage = this.currentPage;
      this.getSpliceDatasets();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.getSpliceDatasets(size);
    },
    jumpPage() {
      // console.log(+this.whichPage);
      if (+this.whichPage < 1) {
        this.whichPage = 1;
      }
      if (+this.whichPage > this.totalPages) {
        this.whichPage = this.totalPages;
      }
      this.currentPage = +this.whichPage;
      this.getSpliceDatasets();
    },
    async getMutationPvalues(data) {

      let axiosSource = axios.CancelToken.source();
      this.request1 = { cancel: axiosSource.cancel, msg: "Loading..." };
      // console.log(this.request1);

      axios.post('https://ngdc.cncb.ac.cn/ascancer/api/regexp/mut/pval', data,
        { cancelToken: axiosSource.token }).then(res => {

          // console.log(res);
          // console.log(res.data);
          // console.log(typeof res.data) // String

          this.progress_value_1 = 80;
          this.isShowNoPsiText = false;

          // String ---> Object
          // let data = eval('(' + res.data + ')')
          let data = JSON.parse(res.data.data);
          // console.log(data);
          // console.log(typeof data) // Object

          if (Object.keys(data).length > 0) {

            this.mutationGeneNames = data.gene_name.slice(0, 10); // show first 10 genes
            this.pValues_mut = data.p_value.slice(0, 10); // show first 10 genes
            let genename = data.gene_name.slice(0, 10).join(',');

            // console.log(genename);
            let projectid = this.project_select;

            let promise1 = new Promise((resolve, reject) => {
              findMutationByGeneAndCancer(projectid, genename).then(result => {
                // console.log(result);
                this.sampleMutations = [];
                let sampleMutations = [];
                this.mutationGeneNames.forEach(gene => {
                  sampleMutations.push(result && result.filter(v => { return v.gene_name == gene }))
                });
                // console.log(sampleMutations);
                resolve(sampleMutations);
              }).catch(err => {
                reject(err)
              })
            });

            let promise2 = new Promise((resolve, reject) => {
              findCNVByGeneAndCancer(projectid, genename).then(result => {
                // console.log(result);
                this.sampleCNVs = [];
                let sampleCNVs = [];
                this.mutationGeneNames.forEach(gene => {
                  sampleCNVs.push(result && result.filter(v => { return v.gene_name == gene }))
                })
                // console.log(sampleCNVs);
                resolve(sampleCNVs);
              }).catch(err => {
                reject(err)
              })
            });

            Promise.all([promise1, promise2]).then(result => {
              // console.log(result);
              this.progress_value_1 = 100;
              this.sampleMutations = result[0];
              this.sampleCNVs = result[1];
            }).catch(err => {
              console.log(err);
            })
          }
        }).catch(err => {
          // this.progress_value_1 = 100;
          // this.isShowNoPsiText = true;
          console.log(err);
        });
    },
    async getExpressionPvalues(data) {

      let axiosSource = axios.CancelToken.source();
      this.request2 = { cancel: axiosSource.cancel, msg: "Loading..." };
      // console.log(this.request2);

      axios.post('https://ngdc.cncb.ac.cn/ascancer/api/regexp/exp/pval', data,
        { cancelToken: axiosSource.token }).then(res => {

          // console.log(res);
          // console.log(res.data);
          // console.log(typeof res.data) // String

          this.progress_value_2 = 80;
          this.isShowNoPsiText = false;

          // String ---> Object
          let data = JSON.parse(res.data.data);
          // let data = eval('(' + res.data + ')')
          // console.log(data);
          // console.log(typeof data) // Object

          if (Object.keys(data).length > 0) {

            // this.express_gene_list = data.gene_name;
            // this.express_pvalue_list = data.p_value;
            // this.express_rvalue_list = data.r_value;

            this.expressionGeneNames = data.gene_name.slice(0, 10); // show first 10 genes
            this.pValues_exp = data.p_value.slice(0, 10); // show first 10 genes
            this.rValues_exp = data.r_value.slice(0, 10); // show first 10 genes
            let genename = data.gene_name.slice(0, 10).join(',');

            // console.log(genename);
            let projectid = this.project_select;

            findExpressionByGeneAndCancer(projectid, genename).then(result => {
              // console.log(result);
              this.progress_value_2 = 100;
              this.go_loading = false; // go stop loading
              this.sampleExpressions = [];
              this.expressionGeneNames.forEach(gene => {
                this.sampleExpressions.push(result && result.filter(v => { return v.gene_name == gene }))
              })
              // console.log(this.sampleExpressions);
            }).catch(err => {
              console.log(err);
            });
          }
        }).catch(err => {
          // this.progress_value_2 = 100;
          // this.isShowNoPsiText = true;
          console.log(err);
        });
    },
    async getPsiExpressionScatter(data) {
      await getPsiExpressionScatter(data).then(res => {
        // console.log(res);
        // console.log(res.data);
        // console.log(typeof res.data) // String

        this.progress_value_3 = 100;
        this.isShowNoPsiText = false;

        // String ---> Object
        let data = eval('(' + res.data + ')')
        // console.log(data);
        // console.log(typeof data) // Object

        if (!Object.keys(data).includes('error_message')) {
          this.scatter_data = data.scatter_data;
          this.scatter_p = data.p_value;
          this.scatter_r = data.r_value;
        } else {
          this.scatter_error = data.error_message;
        }
      }).catch(err => {
        this.progress_value_2 = 100;
        this.progress_value_3 = 100;
        this.isShowNoPsiText = true;
        console.log(err);
      });
    },
    addNewMutationGene() {

      this.progress_value_1 = 50;

      let num = this.sampleMutations.length;
      this.mutationIndexes.push(num);
      // console.log(this.mutationIndexes);

      let genename = this.mutation_gene_select;
      let projectid = this.project_select;

      let promise1 = new Promise((resolve, reject) => {
        findMutationByGeneAndCancer(projectid, genename).then(result => {
          // console.log(result);
          let sampleMutations = this.sampleMutations;
          result && sampleMutations.push(result);
          resolve(sampleMutations);
        }).catch(err => {
          reject(err)
        })
      });

      let promise2 = new Promise((resolve, reject) => {
        findCNVByGeneAndCancer(projectid, genename).then(result => {
          // console.log(result);
          let sampleCNVs = this.sampleCNVs;
          result && sampleCNVs.push(result);
          resolve(sampleCNVs);
        }).catch(err => {
          reject(err)
        })
      });

      Promise.all([promise1, promise2]).then(result => {
        // console.log(result);
        this.sampleMutations = result[0];
        this.sampleCNVs = result[1];

        // 必须这样写，子组件才能监听到 sampleIDs 变化
        let sampleIDs = this.sampleIDs;
        this.sampleIDs = sampleIDs.slice();
        // 必须放在异步函数里，子组件才能监听到 ！！！
        this.mutationGeneNames.push(genename);
      }).catch(err => {
        console.log(err);
      });

      // 此处必须这样写！
      let data = new URLSearchParams();
      data.append('psi', JSON.stringify(this.samplePsi));
      data.append('project', this.project_select);
      data.append('mut_genename', this.mutation_gene_select);
      // console.log(data);

      axios.post('https://ngdc.cncb.ac.cn/ascancer/api/regexp/mut/pval', data).then(res => {
        // console.log(res);
        // console.log(res.data);
        // console.log(typeof res.data)

        this.progress_value_1 = 100;
        let data = JSON.parse(res.data.data);

        if (Object.keys(data).length > 0) {
          let pvalue = data.p_value[0];
          // console.log(pvalue);
          this.pValues_mut.push(pvalue);
        }
      })
    },
    addNewExpressGene() {
      // first remove before's mutation
      // this.removeSampleExpressionPlot();

      this.progress_value_2 = 50;

      let num = this.sampleExpressions.length;
      this.expressionIndexes.push(num);
      // console.log(this.expressionIndexes);

      let genename = this.express_gene_select;
      // console.log(genename);
      let projectid = this.project_select;

      findExpressionByGeneAndCancer(projectid, genename).then(result => {
        // console.log(result);
        result && this.sampleExpressions.push(result);

        // 必须这样写，子组件才能监听到 sampleIDs 变化
        let sampleIDs = this.sampleIDs;
        this.sampleIDs = sampleIDs.slice();

        // 必须放在异步函数里，子组件才能监听到！！！ 
        this.expressionGeneNames.push(genename);
      }).catch(err => {
        console.log(err)
      });

      // 此处必须这样写！
      let data = new URLSearchParams();
      data.append('psi', JSON.stringify(this.samplePsi));
      data.append('project', this.project_select);
      data.append('exp_genename', this.express_gene_select);

      axios.post('https://ngdc.cncb.ac.cn/ascancer/api/regexp/exp/pval', data)
        .then(res => {
          this.progress_value_2 = 100;
          // String ---> Object
          let data = JSON.parse(res.data.data);
          // let data = eval('(' + res.data + ')')
          // console.log(data);
          // console.log(typeof data) // Object

          if (Object.keys(data).length > 0) {
            let pvalue = data.p_value[0];
            let rvalue = data.r_value[0];
            // console.log(pvalue);
            // console.log(rvalue);
            this.pValues_exp.push(pvalue);
            this.rValues_exp.push(rvalue);
          }
        })
    },
    goToGeneSearchResult(genename) {
      if (genename) {
        this.$router.push({
          path: '/search',
          query: {
            genename: genename,
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      } else if (genename == null || genename == '') {
        window.alert("Sorry, please input the gene name !")
      }
    },
    goToVisualiztion(genename, astype, coordinate) {
      this.$router.push({
        path: '/splicevis',
        query: {
          genename: genename,
          astype: astype,
          coordinate: coordinate
        }
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          logError(err);
        }
      })
    },
    goToSurvival(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router.push({
          path: '/tools/survival/asevent',
          query: {
            genename: genename,
            source: source,
            project: project,
            eventid: eventid
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      }
    },
    goToStaging(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router.push({
          path: '/tools/stage/asevent',
          query: {
            genename: genename,
            source: source,
            project: project,
            eventid: eventid
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      }
    },
    removeSamplePsiPlot() {
      d3.select("div#psi-id1 > svg")
        .selectAll('*').remove();
      d3.select("div#psi-id2 > svg")
        .selectAll('*').remove();
    },
    removeSampleMutationPlot() {
      // d3.selectAll("div.sample-mutation")
      //   .filter(function () { return d3.select(this).attr('id') == gene_name })
      //   .select('svg')
      d3.selectAll("div.sample-mutation > svg")
        .selectAll('*').remove();
    },
    removeSampleExpressionPlot() {
      d3.selectAll("div.sample-expression > svg")
        .selectAll('*').remove();;
    },
    async getAllGeneFromSpliceDataset() {
      await getAllGeneFromSpliceDataset().then(data => {
        // console.log(data);
        if (data) {
          this.gene_list = data;
          this.exp_scatter_gene_list = data;
        }
      }).catch(err => console.error(err))
    },
    async findMutationGeneByCancer() {
      let projectid = this.project_select;
      if (projectid) {
        await findMutationGeneByCancer(projectid).then(
          data => {
            // console.log(data);
            this.mutation_gene_list = data;
          }
        ).catch(err => {
          console.log(err);
        })
      }
    },
    async findExpressionGeneByCancer() {
      let projectid = this.project_select;
      if (projectid) {
        await findExpressionGeneByCancer(projectid).then(
          data => {
            // console.log(data);
            this.express_gene_list = data;
          }
        ).catch(err => {
          console.log(err);
        })
      }
    },
    querySelections(v) {
      this.gene_message = null;
      this.gene_error_message = null;
      this.gene_loading = true;
      setTimeout(() => {
        this.gene_items = this.gene_list.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
        })
        this.gene_loading = false
        // show the no data tips when the gene_search result is null
        if (this.gene_items.length == 0) {
          this.gene_error_message = "Sorry, we cant' find this gene.";
        }
      }, 500)
    },
    mutationQuerySelections(v) {
      this.mutation_gene_message = null;
      this.mutation_gene_error_message = null;
      this.mutation_gene_loading = true;
      setTimeout(() => {
        this.mutation_gene_items = this.mutation_gene_list.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
        })
        this.mutation_gene_loading = false
        // show the no data tips when the gene_search result is null
        if (this.mutation_gene_items.length == 0) {
          this.mutation_gene_error_message = "Sorry, we cant' find this gene.";
        }
      }, 500)
    },
    expressQuerySelections(v) {
      this.express_gene_message = null;
      this.express_gene_error_message = null;
      this.express_gene_loading = true;
      setTimeout(() => {
        this.express_gene_items = this.express_gene_list.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
        })
        this.express_gene_loading = false
        // show the no data tips when the gene_search result is null
        if (this.express_gene_items.length == 0) {
          this.express_gene_error_message = "Sorry, we cant' find this gene.";
        }
      }, 500)
    },
    expScatterQuerySelections(v) {
      this.exp_scatter_gene_message = null;
      this.exp_scatter_gene_error_message = null;
      this.exp_scatter_gene_loading = true;
      setTimeout(() => {
        this.exp_scatter_gene_items = this.exp_scatter_gene_list.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
        })
        this.exp_scatter_gene_loading = false
        // show the no data tips when the gene_search result is null
        if (this.exp_scatter_gene_items.length == 0) {
          this.exp_scatter_gene_error_message = "Sorry, we cant' find this gene.";
        }
      }, 500)
    },
    async findPSIByEventAndCancer(event_id, project_id) {
      await findPSIByEventAndCancer(event_id, project_id).then(result => {
        // console.log(result);
        if (result.length > 0) {
          this.samplePsi = result[0].sample_psi;
          let samples = [];
          this.samplePsi && this.samplePsi.forEach((v, i, a) => {
            samples.push(v.sample_id);
          });
          this.sampleIDs = samples;
        } else {
          this.samplePsi = [];
          this.sampleIDs = [];
        }
      }).catch(err => console.log(err))
    },
    plotPSILegend1() {
      const margin = ({ top: 0, left: 200, right: 100, bottom: 0, });
      const width = 400;
      const height = 30;

      const svg = d3.select("div#psi-legend1 > svg")
      svg.attr("width", width);
      svg.attr("height", height);

      let myColor = d3
        .scaleSequential()
        .domain([0, 1])
        .interpolator(t => d3.interpolateBlues(t));

      // for legend
      const linearGradient = svg.append('defs')
        .append('linearGradient')
        .attr("x1", "0%")
        .attr("y1", "0%")
        .attr("x2", "100%")
        .attr("y2", "0%")
        .attr('id', 'linear-gradient');
      linearGradient
        .selectAll('stop')
        .data([0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1])
        // .data([0, 1])
        .enter()
        .append('stop')
        .attr('offset', (d, i) => d / 1)
        .attr('stop-color', d => myColor(1 - d));
      // Add Legend title
      svg.append('text')
        .text('PSI Value')
        .attr("x", 280)
        .attr("y", 30)
        .attr("font-size", "13")
        .attr("font-family", "Arial")
        .attr("font-weight", "bold")
      // Add legend colorBar, draw the rectangle and fill with gradient
      svg.append('rect')
        .attr('width', width)
        .attr('height', height / 2)
        .attr(
          'transform',
          `translate(${margin.left + 14}, 0)`
        )
        .style('fill', 'url(#linear-gradient)');
      // Add Legend min value
      svg.append('text')
        .text('1.00')
        .attr('x', margin.left + 14)
        .attr('y', 30)
        .attr('font-size', 10)
        .attr("font-family", "Arial")
        .attr("font-weight", "bold")

      // Add Legend max value
      svg.append('text')
        .text('0.00')
        .attr('x', margin.left + 180)
        .attr('y', 30)
        .attr('font-size', 10)
        .attr("font-family", "Arial")
        .attr("font-weight", "bold")

    },
    plotPSILegend2() {
      const margin = ({ top: 0, left: 20, right: 10, bottom: 0, });
      const width = 150;
      const height = 30;

      const svg = d3.select("div#psi-legend2 > svg")
      svg.attr("width", width);
      svg.attr("height", height);

      let myColor = d3
        .scaleSequential()
        .domain([0, 1])
        .interpolator(t => d3.interpolateBlues(t));

      // for legend
      const linearGradient = svg.append('defs')
        .append('linearGradient')
        .attr("x1", "0%")
        .attr("y1", "0%")
        .attr("x2", "100%")
        .attr("y2", "0%")
        .attr('id', 'linear-gradient');
      // let arr = [];
      // for (let i = 0; i <= 100; i += 1) { arr.push(i / 100) }
      // console.log(arr);
      linearGradient
        .selectAll('stop')
        .data([0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1])
        .enter()
        .append('stop')
        .attr('offset', (d, i) => d / 1)
        .attr('stop-color', d => myColor(1 - d));
      // Add Legend title
      svg.append('text')
        .text('PSI Value')
        .attr("x", 70)
        .attr("y", 30)
        .attr("font-size", "10")
        .attr("font-family", "Arial")
        .attr("font-weight", "bold")
      // Add legend colorBar, draw the rectangle and fill with gradient
      svg.append('rect')
        .attr('width', width)
        .attr('height', height / 2)
        .attr(
          'transform',
          `translate(${margin.left + 14}, 0)`
        )
        .style('fill', 'url(#linear-gradient)');
      // Add Legend min value
      svg.append('text')
        .text('1.00')
        .attr('x', margin.left + 14)
        .attr('y', 30)
        .attr('font-size', 10)
        .attr("font-family", "Arial")
        .attr("font-weight", "bold")

      // Add Legend max value
      svg.append('text')
        .text('0.00')
        .attr('x', margin.left + width - 40)
        .attr('y', 30)
        .attr('font-size', 10)
        .attr("font-family", "Arial")
        .attr("font-weight", "bold")

    },
    plotMutationLegend() {

      const margin = ({ top: 0, left: 200, right: 100, bottom: 0, });
      const width = 1500;
      const height = 80;
      const gridWidth = 6;
      const gridHeight = 20;
      const sampleColor = "#BDBDBD";
      const bottom = 6;

      const svg = d3.select("div#mutation-legend > svg");
      // .attr("viewBox", [0, 0, width, height]);
      svg.attr("width", width);
      svg.attr("height", height);


      let categories1 = ["Missense_Mutation", "Silent", "3'UTR",
        "Nonsense_Mutation", "Frame_Shift_Del", "Intron",
        "5'UTR", "RNA", "Splice_Site", "Amplication"];
      let color1 = ["#1F77B4FF", "#FF7F0EFF", "#2CA02CFF", "#D62728FF",
        "#9467BDFF", "#8C564BFF", "#E377C2FF", "#7F7F7FFF", "#BCBD22FF", "red"];
      let categories2 = ["Frame_Shift_Ins", "3'Flank", "5'Flank", "In_Frame_Del",
        "Translation_Start", "Nonstop_Mutation", "In_Frame_Ins", "large deletion",
        "None", "Deep Deletion"];
      let color2 = ["#9EDAE5FF", "#F74ED6FF", "#19B2FFFF", "#32FF00FF", "#FF363CFF",
        "#8CDB5EFF", "#0627B3FF", "#181818FF", "#BDBDBD", "blue"];
      const myColor1 = d3.scaleOrdinal(categories1,
        color1);
      const myColor2 = d3.scaleOrdinal(categories2,
        color2);

      // Legend Title
      svg.append('g')
        .attr("class", "legend-title")
        .append("text")
        .attr("x", 80)
        .attr("y", height / 2 - 10)
        .text("Genetic Alteration")
        .attr("font-size", "13")
        .attr("font-family", "Arial")
        .attr("font-weight", "bold")

      // First Column
      svg.append('g')
        .attr("class", "mutation-category")
        .selectAll()
        .data(categories1)
        .join("rect")
        .attr("x", function (d, i) { return margin.left + 14 + i * (gridWidth + 120) })
        .attr("y", bottom)
        .attr('width', gridWidth)
        .attr('height', gridHeight)
        .style("fill", (d, i) => { if (i < 9) { return sampleColor } else { return "red" } })
      svg.append('g')
        .attr("class", "mutation-category-rect")
        .selectAll()
        .data(categories1)
        .join("rect")
        .attr("x", function (d, i) { return margin.left + 14 + i * (gridWidth + 120) })
        .attr("y", bottom + 6)
        .attr("width", gridWidth)
        .attr("height", gridWidth)
        .style("fill", function (d) { return myColor1(d) })
      svg.append('g')
        .attr("class", "mutation-category-label")
        .selectAll()
        .data(categories1)
        .join("text")
        .attr("x", function (d, i) { return margin.left + 14 + i * (gridWidth + 120) + 10 })
        .attr("y", bottom + 14)
        .text(d => d)
        .attr("font-size", "11")
        .attr("font-family", "Arial")
        .attr("font-weight", "bold")

      // Second Column
      svg.append('g')
        .attr("class", "mutation-category")
        .selectAll()
        .data(categories2)
        .join("rect")
        .attr("x", function (d, i) { return margin.left + 14 + i * (gridWidth + 120) })
        .attr("y", bottom + 25)
        .attr('width', gridWidth)
        .attr('height', gridHeight)
        .style("fill", (d, i) => { if (i < 9) { return sampleColor } else { return "blue" } })
      svg.append('g')
        .attr("class", "mutation-category-rect")
        .selectAll()
        .data(categories2)
        .join("rect")
        .attr("x", function (d, i) { return margin.left + 14 + i * (gridWidth + 120) })
        .attr("y", bottom + 32)
        .attr("width", gridWidth)
        .attr("height", gridWidth)
        .style("fill", function (d) { return myColor2(d) })
      svg.append('g')
        .attr("class", "mutation-category-label")
        .selectAll()
        .data(categories2)
        .join("text")
        .attr("x", function (d, i) { return margin.left + 14 + i * (gridWidth + 120) + 10 })
        .attr("y", bottom + 39)
        .text(d => d)
        .attr("font-size", "11")
        .attr("font-family", "Arial")
        .attr("font-weight", "bold")
    },
    plotExpressLegend() {
      const margin = ({ top: 0, left: 20, right: 10, bottom: 0, });
      const width = 150;
      const height = 30;

      const svg = d3.select("div#expression-legend > svg")
      svg.attr("width", width);
      svg.attr("height", height);

      let myColor = d3
        .scaleSequential()
        .domain([-10, 10])
        .interpolator(t => d3.interpolateRdBu(1 - t));

      // for legend
      const linearGradient = svg.append('defs')
        .append('linearGradient')
        .attr("x1", "0%")
        .attr("y1", "0%")
        .attr("x2", "100%")
        .attr("y2", "0%")
        .attr('id', 'linear-gradient-1');
      linearGradient
        .selectAll('stop')
        .data([-10, -9, -8, -7, -6, -5, -4, -3, -2, -1,
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10])
        .enter()
        .append('stop')
        .attr('offset', (d, i) => i / 20)
        .attr('stop-color', d => myColor(d));
      // Add Legend title
      svg.append('text')
        .text('Expression Value')
        .attr("x", margin.left + 28)
        .attr("y", 28)
        .attr("font-size", "10")
        .attr("font-family", "Arial")
        .attr("font-weight", "bold")
      // Add legend colorBar, draw the rectangle and fill with gradient
      svg.append('rect')
        .attr('width', width)
        .attr('height', height / 2)
        .attr(
          'transform',
          `translate(${margin.left + 10}, 0)`
        )
        .style('fill', 'url(#linear-gradient-1)');
      // Add Legend min value
      svg.append('text')
        .text('-10')
        .attr('x', margin.left + 5)
        .attr('y', 30)
        .attr('font-size', 10)
        .attr("font-family", "Arial")
        .attr("font-weight", "bold")

      // Add Legend max value
      svg.append('text')
        .text('10')
        .attr('x', margin.left + width - 33)
        .attr('y', 30)
        .attr('font-size', 10)
        .attr("font-family", "Arial")
        .attr("font-weight", "bold")
    },
    changeRoute() {
      // console.log('go');
      this.$router.replace({
        path: '/tools/regexp',
        query: {
          genename: this.gene_select,
          source: this.source_select,
          project: this.project_select,
          eventid: this.selectedEvent[0],
        }
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          console.error(err);
        }
      });
    },
    showAll() {
      this.headers.map(h => {
        this.selectedHeader.push(h.text)
      })
    },
    showNone() {
      this.selectedHeader = [];
    },
    showDefault() {
      this.selectedHeader = ['Gene Name', 'Cancer Type', 'AS Type',
        'Event Coordinates', 'ORF', 'PSI Tumor', 'PSI Normal', 'Delta PSI', 'FDR',
        'DASE', 'Visualization', 'Survival', 'Staging'];
    },
    cancel() {
      this.request1.cancel();
      this.request2.cancel();
    },
    downloadOncoprint() {
      // console.log('download');
      let psi_legend_svg = d3.select('div#psi-legend1 > svg')._groups[0];
      // console.log(psi_legend_svg);
      let psi_svg = d3.select('div#psi-id1 > svg')._groups[0];
      // console.log(psi_svg);
      let mutation_svg = d3.selectAll('div.sample-mutation > svg')._groups[0];
      // console.log(mutation_svg);
      let mut_legend_svg = d3.select('div#mutation-legend > svg')._groups[0];
      // console.log(mut_legend_svg);
      let svgs = [...psi_legend_svg, ...psi_svg, ...mutation_svg, ...mut_legend_svg];
      // console.log(svgs);

      let name = 'Splicing_Regulatory_Oncoprint.pdf';
      let sample_no = this.sampleIDs.length;
      // console.log(sample_no);
      let width = sample_no * 7 + 50;
      let height = 40;
      const doc = new window.PDFDocument({ compress: false, size: [width, height] });

      const chunks = [];
      const stream = doc.pipe({
        // writable stream implementation
        write: (chunk) => chunks.push(chunk),
        end: () => {
          const pdfBlob = new Blob(chunks, {
            type: "application/octet-stream",
          });
          var blobUrl = URL.createObjectURL(pdfBlob);
          //window.open(`${blobUrl}?customfilename.pdf`);

          /* custom file name download */
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = blobUrl;
          a.download = name; // <---- 👈 file name
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        },
        // readable streaaam stub iplementation
        on: (event, action) => { },
        once: (...args) => { },
        emit: (...args) => { },
      });

      for (let index = 0; index < svgs.length; index++) {
        if (index < svgs.length - 1) {
          window.SVGtoPDF(doc, svgs[index], -30, 5, { useCSS: true });
          doc.addPage();
        } else if (index == svgs.length - 1) {
          window.SVGtoPDF(doc, svgs[index], -30, 0, { useCSS: true });
          doc.addPage();
        }
      }
      doc.end();
    },
    downloadHeatmap() {
      // console.log('download');
      let psi_legend_svg = d3.select('div#psi-legend2 > svg')._groups[0];
      // console.log(psi_legend_svg);
      let psi_svg = d3.select('div#psi-id2 > svg')._groups[0];
      // console.log(psi_svg);
      let expression_svg = d3.selectAll('div.sample-expression > svg')._groups[0];
      // console.log(expression_svg);
      let exp_legend_svg = d3.select('div#expression-legend > svg')._groups[0];
      // console.log(exp_legend_svg);
      let svgs = [...psi_legend_svg, ...psi_svg, ...expression_svg, ...exp_legend_svg];
      // console.log(svgs);

      let name = 'Splicing_Regulatory_Heatmap.pdf';
      let width = 900;
      let height = 40;
      const doc = new window.PDFDocument({ compress: false, size: [width, height] });

      const chunks = [];
      const stream = doc.pipe({
        // writable stream implementation
        write: (chunk) => chunks.push(chunk),
        end: () => {
          const pdfBlob = new Blob(chunks, {
            type: "application/octet-stream",
          });
          var blobUrl = URL.createObjectURL(pdfBlob);
          //window.open(`${blobUrl}?customfilename.pdf`);

          /* custom file name download */
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = blobUrl;
          a.download = name; // <---- 👈 file name
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        },
        // readable streaaam stub iplementation
        on: (event, action) => { },
        once: (...args) => { },
        emit: (...args) => { },
      });

      for (let index = 0; index < svgs.length; index++) {
        window.SVGtoPDF(doc, svgs[index], 0, 5, { useCSS: true });
        doc.addPage();
      }
      doc.end();
    }
  }
}
</script>

<style scoped lang="sass">
a
  text-decoration: none
  color: #2196F3

a:hover
  text-decoration: underline

.v-data-table ::v-deep th
  font-size: 0.87rem !important
.v-data-table ::v-deep td
  font-size: 0.875rem !important

.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 0.875rem

// .v-sheet.v-card
//   border-radius: 15px

.v-card__title
  line-height: 0.5rem

.theme--light.v-data-table .v-data-footer
  border-top: 0

.data-table-style
  border: thin solid rgba(0, 0, 0, 0.12)

.v-item-group
  flex: 0 1 auto
  position: relative
  display: inline-flex
  flex-wrap: wrap
  max-width: 100%
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)

.pagesize-select
  max-width: 6%

.jump-select
  max-width: 6%

.breadcrumb
  line-height: 1
  display: inline-block
  margin: 0 0
  vertical-align: middle
  padding: 8px 15px
  margin-top: -5px
  margin-bottom: 10px
  list-style: none
  background-color: #f5f5f5
  border-radius: 4px

#splice-mutation-explorer
  overflow: scroll
  // border: thin solid rgba(0, 0, 0, 0.12)
  // border: 2px solid #000

// #splice-expression-heatmap
//   overflow: scroll
//   border: thin solid rgba(0, 0, 0, 0.12)
//   border: 2px solid #000

.v-progress-circular
  margin: 1rem
  left: 43%

#mutation-gene-search
  max-width: 25%
  margin: auto

#heatmap-gene-search
  max-width: 30%
  margin: auto

#scatter-gene-search
  max-width: 40%
  margin: auto

// #easy-go-top
//   background-color: #2196F3 !important

// set the width of guide
::v-deep .v-step
  max-width: 600px
  text-align: start

// set the style of highlight
.v-tour__target--highlighted
  border: 1px red solid
  border-radius: 0.8rem
  box-shadow: 0 0 0 99999px rgba(0,0,0,.4)

.guide-btn-style
  position: fixed
  right: 1%
  top: 90%
  transform: translateY(-50%)
  z-index: 99

.v-input--selection-controls
  margin-top: 2px
  padding-top: 0px
</style>